import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import {Translate} from "../../../config/Translate";
import AppCard from "../../components/layouts/components/AppCard";
import AppAnimate from "../../components/AppAnimate";
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {connect} from "trim-redux";
import MakeShop from "./parts/MakeShop";

class MyShopPage extends React.Component {
    render() {
        let {user} = this.props;
        let shop_id = !!user.shops ? !!user.shops[0] ? user.shops[0].id : 0 : 0;
        return(
            <AppAnimate animation='transition.slideUpIn' delay={200} title={!!shop_id ? Translate.editShop : Translate.makeShop}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={!!shop_id ? Translate.editShop : Translate.makeShop}
                            action={
                                <BreadCrumbs singleLevel firstText={!!shop_id ? Translate.editShop : Translate.makeShop}/>
                            }>
                            <MakeShop edit={!!shop_id} shop_id={shop_id }/>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        )
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MyShopPage))));